import { createAsyncTypes } from 'utils/ActionCreator'

import {
  DEFAULT_MANAGER_REPORT_DAY_OF_WEEK,
  DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD,
  PARTICIPANTS_EXCLUDE_FILTER_VALUES,
} from 'containers/AwarenessCenter/constants'

const typeKey = 'AwarenessCenter/WizardTrainingCampaign'

export const GET_DEFAULT_TRAINING_DATA_ASYNC = createAsyncTypes(
  'GET_DEFAULT_TRAINING_DATA',
  typeKey
)

export const CHANGE_MESSAGE_STEP_PROPERTY = `${typeKey}/CHANGE_MESSAGE_STEP_PROPERTY`
export const VALIDATE_MESSAGE_STEP_FIELDS = `${typeKey}/VALIDATE_MESSAGE_STEP_FIELDS`
export const TOGGLE_SAVE_MAIL_SIGNATURE = `${typeKey}/TOGGLE_SAVE_MAIL_SIGNATURE`

export const DEFAULT_COLLECTION_PERIOD = 7
export const MINIMUM_COLLECTION_PERIOD = 3
export const DEFAULT_REMINDERS_INTERVAL = 2
export const SENDING_EMAILS_PERIOD = 2

export const DEFAULT_TRAINING_PROPERTIES = {
  sendReminderEveryXBusinessDays: DEFAULT_REMINDERS_INTERVAL,
  sendCampaignSummaryToCampaignReportRecipients: true,
  sendCompletionEmail: true,
  sendManagerReportEveryXDays: null,
  managerReportRemindersThreshold: DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD,
  managerReportDayOfWeek: DEFAULT_MANAGER_REPORT_DAY_OF_WEEK,
}

export const DEFAULT_TRAINING_CAMPAIGN_OBJECT = {
  // name: '',
  // defaultLocaleId: null,
  // timezone: null,
  // closeTime: '',
  // launchDate: '',
  // launchTime: '',

  participants: {
    page: 1,
    selectorLoader: false,
    modalLoader: false,
    error: null,
    modalSearch: '',
    excludeFilter: PARTICIPANTS_EXCLUDE_FILTER_VALUES.INCLUDED,
    included: {},
    excluded: {},
    items: [],
    meta: {
      count: 0,
    },
    includedSelectionIds: [],
    excludedSelectionIds: [],
  },
  randomizedScenarios: true, // default
  selectedTrainingVideo: [],
  messageStep: {
    fields: {
      subject: '',
      message: '',
      includeLogo: true,
      useDesignedImage: true,
      mailSignature: '',
      fromEmail: '',
    },
    validations: {},
  },
  saveMailSignature: false,
  trainingReminders: [],
  ...DEFAULT_TRAINING_PROPERTIES,
}
